var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),(_vm.$store.state.isLoading)?_c('div',[_c('Loader')],1):_vm._e(),(!_vm.$store.state.isLoading)?_c('div',[_c('router-view')],1):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }